export default __webpack_public_path__ + "static/media/miguel-lopes-16.09a8294c.jpg";